const metadata = name => typeof document === 'undefined'
  ? '' : document.querySelector(`meta[name="xiaoying-${name}"]`)?.content || '';

export const BUILD_ID = metadata('build-id');
export const VERSION = metadata('version') || '开发版';
export const BUILD_TIME = metadata('built-at');
export const BUILD_DATE = BUILD_TIME ? new Date(BUILD_TIME).toLocaleDateString('zh-CN', { timeZone: 'Asia/Shanghai' }) : '本地开发';
export const COMPANY_CN = '扬州红影智投文化科技有限公司';
export const COMPANY_EN = 'Yangzhou Hongying Zhitou Culture & Technology Co., Ltd.';
